var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGrouped = function SvgGrouped(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4917_255530)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 4,
    height: 4,
    fill: "var(--iconColor, currentColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 4,
    height: 4,
    fill: "var(--iconColor, currentColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3,
    width: 4,
    height: 4,
    fill: "var(--iconColor, currentColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 18,
    height: 4,
    fill: "var(--iconColor, currentColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 8,
    height: 4,
    fill: "var(--iconColor, currentColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 7,
    height: 4,
    fill: "var(--iconColor, currentColor)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4917_255530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGrouped);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "grouped.6f4e549699b541c7d4d1965e5f7a6e0c.svg";